import { DetailsPage } from 'pageModules/DetailsPage';

export default DetailsPage;
